import { useConditions } from 'Hooks'
import { useIntl } from 'react-intl'
import { useRecoilValue, useResetRecoilState } from 'recoil'

import ErrorFeedback from 'Components/ErrorFeedback'
import ModalOfferLightUpsell from 'Components/ModalOfferLightUpsell'
import PageContainer from 'Components/PageContainer'
import { EmptyState, ToastContainer, Tooltip } from 'mailup-web-components'
import emptyStateTemplate from 'mailup-web-components/resources/mailup-web-app/img/svg/empty-state-template.svg'
import Pagination from 'Pages/TemplateList/Pagination'
import { modalOfferLightUpsellState } from 'Pages/TemplateList/recoil/state/modals'
import Header from './Header'
import ModalCopy from './ModalCopy'
import ModalDelete from './ModalDelete'
import { Results } from './Results'
import { Search } from './Search'
import { Tabs } from './Tabs'

import {
  TEMPLATE_TYPE_BASIC,
  TEMPLATE_TYPE_LOCAL,
  TEMPLATE_TYPE_RICH
} from 'Constants/index'
import {
  resultsState,
  resultsStateEmptyState
} from 'Pages/TemplateList/recoil/state/results'
import { pageErrorState } from './recoil/state/page'

const TemplateList = () => {
  const intl = useIntl()

  const { error, severity } = useRecoilValue(pageErrorState)

  const handleClickReload = () => {
    window.location.reload()
  }

  const isEmptyState = useRecoilValue(resultsStateEmptyState)
  const { items } = useRecoilValue(resultsState)
  const hasResults = !!items.length
  const [hasNoMailupTemplates] = useConditions('uo:NOMAILUPTEMPLATES')

  const { show: showModalOfferLightUpsell } = useRecoilValue(
    modalOfferLightUpsellState
  )
  const closeModalOfferLightUpsell = useResetRecoilState(
    modalOfferLightUpsellState
  )

  const buildTabs = () => {
    const basicTabs = [
      {
        label: intl.formatMessage({
          id: 'Load.Bee.TemplatesCustomTabTitle'
        }),
        id: `${TEMPLATE_TYPE_LOCAL}`,
        content: (
          <>
            {isEmptyState ? (
              <EmptyState
                thumbSrc={emptyStateTemplate}
                title={intl.formatMessage({
                  id: 'Load.Bee.TemplatesRichEmptyTitle'
                })}
                description={intl.formatMessage({
                  id: 'Load.Bee.TemplatesRichEmptyMessage'
                })}
              />
            ) : (
              <>
                <Search type={TEMPLATE_TYPE_LOCAL} />
                <Results type={TEMPLATE_TYPE_LOCAL} />
                {hasResults && <Pagination />}
              </>
            )}
          </>
        )
      },
      {
        label: intl.formatMessage({
          id: 'Load.Bee.TemplatesBasicTabTitle'
        }),
        id: `${TEMPLATE_TYPE_BASIC}`,
        content: <Results type={TEMPLATE_TYPE_BASIC} />
      }
    ]
    const richTab = {
      label: intl.formatMessage({
        id: 'Load.Bee.TemplatesRichTabTitle'
      }),
      id: `${TEMPLATE_TYPE_RICH}`,
      content: <Results type={TEMPLATE_TYPE_RICH} />
    }

    return hasNoMailupTemplates ? basicTabs : [...basicTabs, richTab]
  }

  return (
    <>
      <Tooltip />
      <ToastContainer />
      <Header />
      <ModalCopy />
      <ModalDelete />
      <ModalOfferLightUpsell
        show={showModalOfferLightUpsell}
        onClose={closeModalOfferLightUpsell}
      />
      <PageContainer>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={handleClickReload}
        />
        {!error && <Tabs tabs={buildTabs()} />}
      </PageContainer>
    </>
  )
}

export default TemplateList
